export default function getProtocol() {
  'use strict'
  return window.location.href.split(':')[0]
}




// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/util/getProtocol.js